"use strict";

exports.__esModule = true;
exports.getSimplifiedTagsArray = void 0;

var _filterCustomTags = require("../filters/filter-custom-tags");

var _filterIdentifiedTags = require("../filters/filter-identified-tags");

var _renderer = require("../../../renderer");

var _updateBySchema = require("../values/update-by-schema");

var _Identifiers = require("../../types/Identifiers");

var _getSimplifiedTag = require("./get-simplified-tag");

var _TagSchemas = require("../../types/TagSchemas");

var getSimplifiedTagsArray = function getSimplifiedTagsArray(advancedSeoData) {
  var url = (0, _renderer.getCanonical)(advancedSeoData);
  advancedSeoData = (0, _filterIdentifiedTags.filterIdentifiedTags)(advancedSeoData);
  advancedSeoData = (0, _filterCustomTags.filterCustomTags)(advancedSeoData);
  var updatedTags = (0, _updateBySchema.updateValueBySchema)(advancedSeoData.tags, _TagSchemas.TAG_SCHEMAS[_Identifiers.GENERAL_IDENTIFIERS.LINK]('canonical'), url);
  var simplifiedTagsArray = updatedTags.map(_getSimplifiedTag.getSimplifiedTag);
  return simplifiedTagsArray;
};

exports.getSimplifiedTagsArray = getSimplifiedTagsArray;